import React from 'react'

const ExploreIcon = () => {
  return (
    <div style={{ transform: 'translate(-1px,2px)' }}>
     <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 256 256"
          style={{ fill: '#000000' }}
        >
          <g fill="#00A1AE" fillRule="nonzero">
            <g transform="scale(5.33,5.33)">
                <path d="M 24 2.0253906 C 12.112 2.5373906 2.5373906 12.112 2.0253906 24 L 5 24 C 5.552 24 6 24.447 6 25 C 6 25.553 5.552 26 5 26 L 2.0253906 26 C 2.5373906 37.888 12.112 47.462609 24 47.974609 L 24 45 C 24 44.447 24.448 44 25 44 C 25.552 44 26 44.447 26 45 L 26 47.974609 C 37.888 47.462609 47.462609 37.888 47.974609 26 L 45 26 C 44.448 26 44 25.553 44 25 C 44 24.447 44.448 24 45 24 L 47.974609 24 C 47.462609 12.112 37.888 2.5373906 26 2.0253906 L 26 5 C 26 5.553 25.552 6 25 6 C 24.448 6 24 5.553 24 5 L 24 2.0253906 z M 37.09375 12.003906 C 37.3185 12.025531 37.535578 12.123969 37.705078 12.292969 C 38.045078 12.632969 38.096125 13.163547 37.828125 13.560547 L 28.154297 27.884766 C 28.082297 27.990766 27.990766 28.081297 27.884766 28.154297 L 13.560547 37.828125 C 13.390547 37.942125 13.194 38 13 38 C 12.742 38 12.486969 37.900031 12.292969 37.707031 C 11.953969 37.368031 11.901922 36.836453 12.169922 36.439453 L 21.845703 22.115234 C 21.917703 22.009234 22.009234 21.918703 22.115234 21.845703 L 36.439453 12.169922 C 36.637953 12.036422 36.869 11.982281 37.09375 12.003906 z M 23.396484 23.396484 L 16.71875 33.28125 L 26.603516 26.603516 L 23.396484 23.396484 z"></path>
            </g>
          </g>
        </svg>
        </div>
  )
}

export default ExploreIcon
